<div class="back-to-profile" (click)="showOption ? (showOption = false) : GoToMyTabs(0)"><i class="fa fa-chevron-left" aria-hidden="true"></i><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</div>
<div>
  @if(showOption){
  <!-- @toggleAnimation -->
  <div class="equip">
    <div class="equip__nav">
      <div class="equip__nav--name">Equip - {{ adjustName(selectedType) | titlecase }}</div>
    </div>
    <div class="equip__body">
      <div class="all" *ngFor="let i of subCategoryList; let j = index" (click)="equipItem(i)">
        <div class="item">
          <div class="item__img">
            <img loading="lazy" [src]="imgUrl + i.profileCharacter.image" (error)="commonService.handleError($event)" [alt]="i.profileCharacter.image" [ngClass]="{ zoom: i?.category === 'armor' }" />
          </div>
          <div class="item__body">
            <div class="item__body--name">
              {{ i?.profileCharacter?.name | titlecase }}
            </div>
            <div class="item__body--desc">
              {{ i?.profileCharacter?.description | titlecase }}
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="subCategoryList && subCategoryList.length > 0">
        <div class="equip__body--remove" (click)="unEquipItem(subCategoryList[0])">
          <i class="fa-solid fa-trash"></i>
          <div class="text">Remove {{ selectedType }}</div>
        </div>
      </ng-container>
    </div>
  </div>
  } @else {
  <!-- @toggleAnimation -->
  <section class="my-avatar">
    <div class="profile-image">
      <div class="name">{{ charName || "No Name" }}</div>
      <div class="avatar-images" [ngStyle]="{ 'background-image': primaryImage }" id="profilePictureElementBro" #elementToConvert>
        <ng-container *ngFor="let i of primaryImageList">
          @if(showBaseImage){
          <img loading="lazy" [ngStyle]="{ 'z-index': getZIndex('eyes') }" src="../../../../../../assets/images/profile-charactor/base-male.png" />
          }
          <img loading="lazy"
            [ngStyle]="{
              'z-index': getZIndex(i?.profileCharacter?.category)
            }"
            *ngIf="i?.profileCharacter?.category != 'base' && i?.profileCharacter?.category != 'background'"
            [src]="imgUrl + i?.profileCharacter?.image"
          />
        </ng-container>
        <div class="buttons">
          <div class="buttons__item" (click)="GoToMyTabs(2)"><i class="fa-solid fa-shopping-cart"></i></div>
          <div class="buttons__item" (click)="GoToMyTabs(3)"><i class="fa-solid fa-user"></i></div>
        </div>
      </div>
    </div>
    <div class="my-avatars">
      <ng-container *ngFor="let i of profileCharacterTypeImageList; let index = index">
        <ng-container *ngIf="availableItemList[i.category] && availableItemList[i.category].length > 0; else EmptyBox">
          <div class="my-avatars__item" [ngClass]="{ animate: i.animate }" (click)="openEquipModel(i.category)">
            <div class="my-avatars__item--img">
              <div class="top-line"></div>
              <img loading="lazy" [src]="(i?.image.includes('public') ? imgUrl : imgAssetsUrl) + i?.image" [alt]="i.name" />
              <div class="my-avatars__item--name">
                {{ i.name | titlecase }}
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #EmptyBox>
          <div class="my-avatars__item" [ngClass]="{ animate: i.animate }" (click)="openEquipModel(i.category)">
            <div class="my-avatars__item--img">
              <div class="top-line"></div>
              <div class="lock">
                <i class="fa-solid fa-lock"></i>
              </div>
              <div class="my-avatars__item--name">
                {{ i.category | titlecase }}
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
    <div class="text-center pb-4">
      <button class="button-2" (click)="saveAsPNG()"><i class="fa-solid fa-save"></i> Save Avatar</button>
    </div>
  </section>
  }
</div>
